/**
 * Utility for generating ESC/POS commands for thermal printers.
 * Adapted from the standalone relay.js script.
 */

export const ESC = '\x1B';
export const GS = '\x1D';
export const INIT = ESC + '@';
export const CENTER = ESC + 'a' + '\x01';
export const LEFT = ESC + 'a' + '\x00';
export const BOLD_ON = ESC + 'E' + '\x01';
export const BOLD_OFF = ESC + 'E' + '\x00';
export const DOUBLE_SIZE = GS + '!' + '\x11';
export const NORMAL_SIZE = GS + '!' + '\x00';
export const FEED_AND_CUT = ESC + 'd' + '\x03' + GS + 'V' + '\x41' + '\x03';

export function formatLine(label: string, value: string, width = 32) {
    const spaces = width - label.length - value.length;
    return label + ' '.repeat(Math.max(1, spaces)) + value + '\n';
}

export function generateEscPos(order: any) {
    let commands = INIT;

    // Header
    commands += CENTER + BOLD_ON + DOUBLE_SIZE + order.restaurantName + '\n' + NORMAL_SIZE + BOLD_OFF;
    commands += (order.tableNumber ? `Table: ${order.tableNumber}` : 'Takeaway') + '\n';
    commands += `Order ID: ${order.orderId.slice(-8).toUpperCase()}` + '\n';
    commands += `Date: ${new Date(order.createdAt).toLocaleString()}` + '\n';
    commands += '--------------------------------\n' + LEFT;

    // Items
    order.items.forEach((item: any) => {
        const total = (parseFloat(item.price) * item.quantity).toFixed(2);

        // Format: "2x Item Name              10.00"
        let line = `${item.quantity}x ${item.name}`;
        const priceStr = total.toString();
        const spaces = 32 - line.length - priceStr.length;

        if (spaces > 0) {
            line += ' '.repeat(spaces) + priceStr;
        } else {
            line += '\n' + ' '.repeat(32 - priceStr.length) + priceStr;
        }

        commands += line + '\n';
        if (item.customerNote) {
            commands += `  * ${item.customerNote}\n`;
        }
    });

    // Totals
    commands += '--------------------------------\n';
    commands += formatLine('Subtotal', parseFloat(order.subtotal).toFixed(2));
    if (parseFloat(order.tax) > 0) {
        commands += formatLine('Tax', parseFloat(order.tax).toFixed(2));
    }
    if (parseFloat(order.tip) > 0) {
        commands += formatLine('Tip', parseFloat(order.tip).toFixed(2));
    }
    commands += BOLD_ON + DOUBLE_SIZE + formatLine('TOTAL', parseFloat(order.total).toFixed(2)) + NORMAL_SIZE + BOLD_OFF;

    // Footer
    commands += '\n' + CENTER + 'Thank you for your order!\n' + order.restaurantName + '\n\n\n' + FEED_AND_CUT;

    return commands;
}

/**
 * Convert string to Base64 for Capacitor TCP plugin
 */
export function stringToBase64(str: string) {
    return btoa(unescape(encodeURIComponent(str)));
}
